import styles from './footer.module.css'
import { Link } from 'react-router-dom';

function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer className={styles.footer} role="contentinfo">
            <div>
                <a href='mailto:contato@minhaempresa.com' title='Enviar e-mail'>Saber mais sobre a Empresa</a><br/>
                <a href='tel:+550000000000' title='Ligar'>Contatos</a><br/>
                <Link to="/P2P" title="Mercado P2P em tempo real">Mercado P2P</Link>
            </div>
            <span aria-label="Direitos autorais">&copy; {year} Meu App - Todos os direitos reservados.</span>
        </footer>
    );
}

export default Footer;
